import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./css/index.scss";
import "./i18n";
import reportWebVitals from "./reportWebVitals";
import { configureStore } from "@reduxjs/toolkit";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import Loader from "./components/UI/Loader/Loader";
import appReducer from "./store/reducers/app";
import userReducer from "./store/reducers/user";
import rolesReducer from "./store/reducers/roles";
import usersReducer from "./store/reducers/users";
import groupsReducer from "./store/reducers/groups";
import actionsReducer from "./store/reducers/actions";
import modulesReducer from "./store/reducers/modules";
import responsivesReducer from "./store/reducers/responsives";

require("typeface-titillium-web");

const store = configureStore({
  // Automatically calls `combineReducers`
  reducer: {
    app: appReducer,
    user: userReducer,
    roles: rolesReducer,
    users: usersReducer,
    groups: groupsReducer,
    actions: actionsReducer,
    modules: modulesReducer,
    responsives: responsivesReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, //TODO lo ideal es usar objetos serializables en el reducer, investigar e intentar quitarlo
    }),
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <BrowserRouter basename={"/landingpage"}>
      <Suspense fallback={<Loader />}>
        <App />
      </Suspense>
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
